import { CustomerFilterModel, OrderFilterModel } from "../pages/orders/my/tool-panel/filter/customer-filter";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getMobileOrders(
  filter: OrderFilterModel = {},
  limit?: number,
  page?: number,
) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    const query = filter?.textQuery ? `limit=${limit}&page=${page}&filter=${filter?.textQuery}` : `limit=${limit}&page=${page}`
    const filtered = filter?.state ? `${query}&state=${filter.state}` : query;

    return axiosInstance
      .get(
        `${API_URL}/barekampost/admin/orders?${filtered}`,
        authorizationHeader,
      )
      .then((response) => response?.data?.data as any);
  } catch (error) {
    console.error(error);
    return {
      currentPage: 0,
      data: [],
      pageSize: 0,
      totalItems: 0,
    };
  }
}

async function getMobileUsers(
  filter: CustomerFilterModel = {},
  limit?: number,
  page?: number,
) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    const query = filter?.textQuery ? `limit=${limit}&page=${page}&filter=${filter?.textQuery}` : `limit=${limit}&page=${page}`

    return axiosInstance
      .get(
        `${API_URL}/barekampost/admin/users?${query}`,
        authorizationHeader,
      )
      .then((response) => response?.data?.data as any);
  } catch (error) {
    console.error(error);
    return {
      currentPage: 0,
      data: [],
      pageSize: 0,
      totalItems: 0,
    };
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default { getMobileOrders, getMobileUsers };
